import { render } from "./indexTooltip.vue?vue&type=template&id=59cb5bc4"
import script from "./indexTooltip.vue?vue&type=script&lang=js"
export * from "./indexTooltip.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__